import store from '../../../store'

const getFilterParams = () => {
  return store.getters.GET_FILTER_PARAMS
}

const getFilterParamsStatic = () => {
  return store.getters.GET_FILTER_PARAMS_STATIC
}

export {
  getFilterParams,
  getFilterParamsStatic
}



// WEBPACK FOOTER //
// ./src/scripts/modules/store/filters-getters.js